import "@hotwired/turbo-rails"
import { application } from "./controllers/application"
import { registerPoetryControllers } from "@poetry/controllers"
import { registerPoetryChartsControllers } from "@poetry/charts"
import "./controllers"
import "./confirm_destroy"

registerPoetryControllers(application)
registerPoetryChartsControllers(application)
